/**
 * @deprecated
 */
import { escapeBackslashQuery } from '@toggle/helpers/src/utils/strings/strings';
import {
  entities,
  Entity,
  entityArrSchema,
  EntitySearchType,
  FetchEntityRequestBody,
  UseTagSearchParams,
} from '@toggle/toggle';

import { apiFetch, wretchRequest } from '~/utils/api-fetch/apiFetch';

export const entityEndpoints = {
  entity: 'entity/v2/filtered',
  popularEntities: 'entity/v2/search/popular',
  searchEntities: 'entity/v3/search/entities',
  searchCurrencies: 'entity/v3/search/currencies',
  searchEconomies: 'entity/v3/search/economies',
  searchEntityAndEconomies: entities.searchEntityAndEconomies.path,
  entityLookup: entities.entityLookup.path,
};

const SearchQueryEndpoints = {
  [EntitySearchType.Entity]: entityEndpoints.searchEntities,
  [EntitySearchType.Currency]: entityEndpoints.searchCurrencies,
  [EntitySearchType.Economies]: entityEndpoints.searchEconomies,
  [EntitySearchType.EntityAndEconomies]:
    entityEndpoints.searchEntityAndEconomies,
  [EntitySearchType.EntityLookup]: entityEndpoints.entityLookup,
};

export function postEntitiesByQuery(
  query: string,
  searchType: EntitySearchType,
  params: UseTagSearchParams = {},
  forceApiCall?: boolean
) {
  const endPoint = SearchQueryEndpoints[searchType];

  return apiFetch<Entity[]>(`${endPoint}`, {
    schema: entityArrSchema,
    method: 'post',
    body:
      query || forceApiCall
        ? { q: escapeBackslashQuery(query), ...params }
        : {},
  });
}

export const postEntities = (
  entities: FetchEntityRequestBody,
  signal?: AbortSignal
) => {
  return apiFetch<Entity[]>(entityEndpoints.entity, {
    schema: entityArrSchema,
    method: 'post',
    body: entities,
    options: { signal },
  });
};

export const postEntitiesRequest = (
  entities: FetchEntityRequestBody,
  signal?: AbortSignal
) => {
  return wretchRequest<Entity[]>(entityEndpoints.entity, {
    schema: entityArrSchema,
    method: 'post',
    body: entities,
    options: { signal },
  });
};

export const getPopularEntities = () => {
  return apiFetch<Entity[]>(entityEndpoints.popularEntities, {
    schema: entityArrSchema,
  });
};

export const fetchMultipleEntities = async (
  tags: string[],
  signal?: AbortSignal
): Promise<Entity[]> => {
  let entities: Entity[] = [];

  await Promise.all(
    tags.map(tag =>
      postEntities(
        {
          filter: 2,
          args: [tag],
        },
        signal
      ).then(r => {
        if (!r.error && r.data.length > 0) {
          entities.push(r.data[0]);
        }
      })
    )
  );

  return entities;
};
